// R-fix-2026-08-20: 路由级模块权限守卫,URL 直跳时若用户无 canViewModule 权限显示 403 卡。
// 极简化:LockOutlined + '403 无访问权限' + 核心文案,不显示已开通模块列表、
// 不显示"返回项目总览"按钮。权限拒绝硬落地,不引导。

import { Card, Space } from 'antd'
import { LockOutlined } from '@ant-design/icons'
import usePermissions, { MODULE_NAME_MAP } from '../hooks/usePermissions'

// 模块路由映射复用 usePermissions 的 MODULE_NAME_MAP 作为单源(R-audit-2026-08-30 P1-004)
// 这里 re-export 仅用于向后兼容(其他文件可能 import 此处的别名)。
// R-2026-08-22:canonical key 由 'safety' → 'safety_quality'。「安全质量」页面统一门控。
// 老 key 'safety' / 'quality' 作为 alias 保留(向后兼容,防 URL 直跳 legacy URL 报错)。
export { MODULE_NAME_MAP }

const wrapStyle = {
  padding: '40px 24px',
  display: 'flex',
  justifyContent: 'center',
}

const cardStyle = {
  maxWidth: 480,
  width: '100%',
}

/**
 * 路由级模块权限守卫。
 * - isLoading: 返"加载中"
 * - 有权限或 platform_owner: 返 children
 * - 无权限: 返极简 403 卡(只有 LockOutlined + 标题 + 文案,**无**已开通模块列表,**无**返回按钮)
 */
export default function RequireModule({ module: moduleKey, children }) {
  const { canViewModule, isPlatformOwner, isLoading } = usePermissions()

  if (isLoading) {
    return <div style={{ padding: 40, textAlign: 'center', color: '#595959' }}>加载中...</div>
  }

  if (isPlatformOwner || canViewModule(moduleKey)) {
    return children
  }

  return (
    <div style={wrapStyle}>
      <Card style={cardStyle} styles={{ body: { padding: 28 } }}>
        <Space align="center" style={{ marginBottom: 12 }}>
          <LockOutlined style={{ fontSize: 22, color: '#faad14' }} />
          <span style={{ fontSize: 18, fontWeight: 600, color: '#262626' }}>403 无访问权限</span>
        </Space>
        <div style={{ color: '#595959', fontSize: 13, lineHeight: 1.7 }}>
          您没有访问「<strong style={{ color: '#262626' }}>{MODULE_NAME_MAP[moduleKey] || moduleKey}</strong>」模块的权限,请联系组织管理员开通。
        </div>
      </Card>
    </div>
  )
}